<script lang="ts">
	import { selectedClientStore } from '../../../../api/EnzianDataApi';
	import IconButton from '../../../../basic/buttons/IconButton.svelte';
	import DefaultSimpleList from '../../../../basic/list/DefaultSimpleList.svelte';
	import Searchbar from '../../../../basic/search/Searchbar.svelte';
	import { onDestroy } from 'svelte';
	import { _ } from 'svelte-i18n';
	import { type SettingPaymentPeriod } from '../../../../types/BasicTypes';
	import CreateSettingPaymentPeriod from './CreateSettingPaymentPeriod.svelte';
	import ListItemSettingPaymentPeriod from './ListItemSettingPaymentPeriod.svelte';
	import PatchSettingPaymentPeriodDetail from './PatchSettingPaymentPeriodDetail.svelte';
	import { createSettingPaymentPeriodStore } from '../../../../stores/SettingPaymentPeriodsStore.svelte';

	interface Props {
		showDetailOnClick?: boolean;
		onSelectionChanged?: (item: SettingPaymentPeriod) => void;
	}

	let { showDetailOnClick = true, onSelectionChanged }: Props = $props();

	let settingPaymentPeriodStore = $state(createSettingPaymentPeriodStore());

	let editSettingPaymentPeriod: SettingPaymentPeriod | undefined = $state();
	let showCreate: boolean = $state(false);

	//Add reactivity for client change
	let clientUnsubscriber = selectedClientStore.subscribe((client) => {
		if (client == null) return;
		//Load the data
		settingPaymentPeriodStore.applyFilter();
	});

	//Unsubscribe again and clean up
	onDestroy(() => {
		//Clean up the data
		settingPaymentPeriodStore.clear();
		clientUnsubscriber();
	});
</script>

<div class="h-full overflow-y-auto pt-8">
	<!--Add the list of document types-->
	<div class="h-full grid grid-rows-[auto_1fr]">
		<div class="items-center flex pb-9 pl-8 gap-8">
			<Searchbar
				onSearchTrigger={() => {
					settingPaymentPeriodStore.applyFilter();
				}}
				placeholder={$_('settings.basic.payment_periods.lbl_hint')}
				bind:filter={settingPaymentPeriodStore.listFilter}
			/>
			<IconButton
				iconName="plus"
				hoverText={$_('settings.basic.document_labels.lbl_add')}
				primary={true}
				onClick={() => {
					showCreate = true;
				}}
			/>
		</div>

		<DefaultSimpleList
			itemComponent={ListItemSettingPaymentPeriod}
			bind:store={settingPaymentPeriodStore}
			onAddRequest={() => {
				showCreate = true;
			}}
			onEditRequest={(item) => {
				if (showDetailOnClick) {
					editSettingPaymentPeriod = item as SettingPaymentPeriod;
				}
			}}
			onSelectionChanged={(item) => {
				if (showDetailOnClick) {
					editSettingPaymentPeriod = item as SettingPaymentPeriod;
				}
				onSelectionChanged?.(item as SettingPaymentPeriod);
			}}
		/>
	</div>

	<!--We do not have a detail page for labels-->
	{#if editSettingPaymentPeriod}
		<PatchSettingPaymentPeriodDetail
			onModalClose={() => {
				editSettingPaymentPeriod = undefined;
			}}
			store={settingPaymentPeriodStore}
			settingPaymentPeriod={editSettingPaymentPeriod}
		/>
	{/if}

	{#if showCreate}
		<CreateSettingPaymentPeriod
			store={settingPaymentPeriodStore}
			onModalClose={() => {
				showCreate = false;
			}}
		/>
	{/if}
</div>
